import { render, staticRenderFns } from "./BlockType25.vue?vue&type=template&id=a8fc98a4&scoped=true&"
import script from "./BlockType25.vue?vue&type=script&lang=ts&"
export * from "./BlockType25.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType25.vue?vue&type=style&index=0&id=a8fc98a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fc98a4",
  null
  
)

export default component.exports